export const formatDate = (isoString: string, locale: string): string => {
  try {
    const date = new Date(isoString);
    let res = date.toLocaleDateString(locale || "en", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    if (locale.startsWith("ru")) {
      res = res.replace(/\s*г\.$/, "").trim();
    }
    return res;
  } catch {
    return isoString;
  }
};

export const formatShortDate = (isoString: string, locale: string): string => {
  try {
    const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoString);
    const date = dateOnly
      ? new Date(
          Number(dateOnly[1]),
          Number(dateOnly[2]) - 1,
          Number(dateOnly[3]),
        )
      : new Date(isoString);
    const normalizedLocale = locale || "en";
    const dateLocale = normalizedLocale.startsWith("en")
      ? "en-GB"
      : normalizedLocale;

    return date.toLocaleDateString(dateLocale, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return isoString;
  }
};
